<template>
  <div class="the-info" v-if="isNeedQueryOnlineUsers && hasAtLeastOnlineUser">  
    <div>
      <el-table
        :data="onlineUsers"
        size="mini"
      >
        <el-table-column
          :label="$t('common.onlineUsers')"
        >
          <template v-slot="{row}">
            <span>
              {{`(${row.name}) ${row.account}`}}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import axios from "axios";
const AUTH_DOMAIN = window.config.domainHost;

export default {
  props:  {
    serviceID: String,
    errorCode: String
  }, // 
  data() {
    return {
      onlineUsers: [],
      table: {
        columns: [
          { title: 'Account', field: 'account'},
          { title: 'Username', field: 'name' },
        ],

      }
    }
  },
  computed: {
    isNeedQueryOnlineUsers() {
      return this.serviceID !== "" && this.errorCode === "serviceQuotaNotEnough"
    },
    hasAtLeastOnlineUser(){
      return this.onlineUsers.length > 0
    }
  },
  methods: {
    fetchOnlineUsers() {
      axios
        .get(
          `https://${AUTH_DOMAIN}/login/authentication-service/authentication/online-users-when-login?service=${this.serviceID}`
        )
        .then(res=> {
          if (res.data.code === 0) {
            this.onlineUsers = res.data.result
          }
        })
    }
  }, // End of methods  
  created() {
    if(this.isNeedQueryOnlineUsers === true) {
      this.fetchOnlineUsers()
    }
  }
}
</script>
<style lang="scss" scoped>
.the-info {
  padding:20px;
  transform: translateY(-10px);
  background: #edf3fc;
  min-height: 40px;
  border-radius: 0px 0px 10px 10px;
}

</style>